var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAttendanceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 12.809,
    height: 15.969,
    viewBox: "0 0 12.809 15.969",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:url(#a);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x2: 1,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#D23B7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D23B7D"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-15.5 -15.516)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.5 15.516)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M9.741,14.375a3.462,3.462,0,1,0-3.462-3.482h0A3.484,3.484,0,0,0,9.741,14.375Z",
    transform: "translate(-4.381 -5.205)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M12.72,1.012a1.469,1.469,0,0,0-1.606-.98A1.444,1.444,0,0,0,9.843,1.471v5a1.674,1.674,0,0,1-.125.626c-.375.98-.751,1.939-1.084,2.919a.471.471,0,0,1-.542.375H2.544A2.447,2.447,0,0,0,0,12.961v2.356c0,.521.167.667.667.667H10.03c.521,0,.688-.167.688-.667V13.149a1.345,1.345,0,0,1,.063-.417L12.658,7.79a2.161,2.161,0,0,0,.146-.813V1.7A1.95,1.95,0,0,0,12.72,1.012Z",
    transform: "translate(0 -0.016)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttendanceIcon);
export default __webpack_public_path__ + "static/media/AttendanceIcon.4300d3389b245a7709dbdefa32f6a6c9.svg";
export { ForwardRef as ReactComponent };